import { FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import type { BureauFeatures } from '../api/api'

export interface BureauFeatureToggleProps {
  value: BureauFeatures | undefined
  onToggle: (features: BureauFeatures) => void
  isLoading: boolean
  isError: boolean
}

export const BureauFeatureToggle = ({ value, onToggle, isLoading, isError }: BureauFeatureToggleProps) => {
  const values: BureauFeatures = { agencyPortal: Boolean(value?.agencyPortal), agencyTeams: Boolean(value?.agencyTeams) }
  const disabled = isLoading || isError

  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <FormControlLabel
        disabled={disabled}
        onChange={(_, checked) => onToggle({ ...values, agencyPortal: checked })}
        sx={{ gap: 1 }}
        labelPlacement="start"
        control={
          <Switch
            slotProps={{ input: { 'aria-label': 'agency-portal-switch' } }}
            disabled={disabled}
            role="switch"
            name="agency-portal"
            checked={values.agencyPortal}
            value={values.agencyPortal}
          />
        }
        label={
          <Typography variant="p4Regular" color="textSecondary">
            Agency Portal
          </Typography>
        }
      />
      <FormControlLabel
        disabled={disabled}
        onChange={(_, checked) => onToggle({ ...values, agencyTeams: checked })}
        sx={{ gap: 1 }}
        labelPlacement="start"
        control={
          <Switch
            slotProps={{ input: { 'aria-label': 'agency-teams-switch' } }}
            disabled={disabled}
            role="switch"
            name="agency-teams"
            checked={values.agencyTeams}
            value={values.agencyTeams}
          />
        }
        label={
          <Typography variant="p4Regular" color="textSecondary">
            Agency Teams
          </Typography>
        }
      />
    </Stack>
  )
}
